const state = {
  activities: {
    byId: {},
    allIds: []
  },
  followUps: {
    byId: {},
    allIds: []
  },
  releaseNotes: {
    byId: {},
    allIds: []
  },
  registeredDevices: {
    byId: {},
    allIds: []
  },
  currentDevice: {
    id: "",
    deviceId: ""
  }
};
export default state;